import { FaCar } from "react-icons/fa6";
import { BsTools } from "react-icons/bs";
import { RiSteering2Line } from "react-icons/ri";
import { FaCarCrash } from "react-icons/fa";
import { Link } from "react-router-dom";

export const OurServices = () => {
  const services = [
    {
      icon: FaCar,
      title: "Truevalue",
      description:
        "Trusted and user friendly platform for buying, selling and exchanging pre-owned cars.",
      buttonText: "Explore",
      link: "/truevalue",
    },
    {
      icon: FaCarCrash,
      title: "Insurance",
      description:
        "Get hassle-free Maruti Suzuki insurance renewal & claims support with trusted partners.",
      buttonText: "Renew Now",
      link: "/insurance",
    },
    {
      icon: BsTools,
      title: "Book a Service",
      description:
        "Maruti Suzuki trained professionals for a hassle-free experience.",
      buttonText: "Explore",
      link: "/book-a-service",
    },
    {
      icon: RiSteering2Line,
      title: "Driving School",
      description:
        "Maruti Driving Schools with latest technology enabled simulators.",
      buttonText: "Explore",
      link: "/driving-school",
    },
  ];

  return (
    <section className="">
      <h3 className="xl:text-3xl md:text-xl text-lg font-medium text-center">
        Our Services
      </h3>
      <div className="bg-red-600 h-1 rounded-full w-20 md:w-[100px] xl:w-[180px] mx-auto my-2"></div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-10">
        {services.map((item, index) => {
          const Icon = item.icon;

          return (
            <div
              key={index}
              className="group relative bg-gray-100 h-[320px] flex flex-col items-center text-center px-8 py-12 overflow-hidden transition-all duration-300 hover:bg-[#7b7b7b] hover:scale-105 hover:duration-300 hover:shadow-2xl hover:shadow-gray-500 rounded-lg"
            >
              {/* ICON */}
              <Icon className="text-[48px] text-red-600 group-hover:text-white transition-colors duration-300" />

              {/* TITLE */}
              <h3 className="mt-6 text-[18px] font-semibold text-gray-800 group-hover:text-white">
                {item.title}
              </h3>

              {/* DESCRIPTION */}
              <p className="mt-4 text-gray-600 group-hover:text-white text-[14px] leading-relaxed">
                {item.description}
              </p>

              {/* READ MORE BAR */}
              <Link
                to={item.link}
                className="absolute bottom-0 left-0 w-full h-[60px]
    flex items-center justify-center
    text-sm font-medium
    overflow-hidden"
              >
                {/* BLUE BACKGROUND (moves) */}
                <span
                  className="
      absolute inset-0
      bg-[#DC2627]
      translate-y-full
      transition-transform duration-300 ease-out
      group-hover:translate-y-0
    "
                ></span>

                {/* TEXT (never moves) */}
                <span className=" z-10 text-gray-500 group-hover:text-white transition-colors duration-300">
                  {item.buttonText}
                </span>
              </Link>
            </div>
          );
        })}
      </div>
    </section>
  );
};
